<template>
  <div class="gala-container">
    <!-- Admin Management Section -->
    <div v-if="isAdmin" class="admin-section">
      <div class="section-tabs">
        <button
          @click="activeTab = 'events'"
          :class="['tab-button', { active: activeTab === 'events' }]"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12.01" y2="12"/>
          </svg>
          Gála Események
        </button>
        <button
          @click="activeTab = 'management'"
          :class="['tab-button', { active: activeTab === 'management' }]"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
          Gala Kezelés
        </button>
        <button
          v-if="isTeacher"
          @click="activeTab = 'gift'"
          :class="['tab-button', { active: activeTab === 'gift' }]"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 1l4 4-4 4"/>
            <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
            <path d="M7 23l-4-4 4-4"/>
            <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
          </svg>
          Jegyátadás
        </button>
      </div>
    </div>

    <!-- Management Tab Content (Admin Only) -->
    <div v-if="isAdmin && activeTab === 'management'">
      <GalaItem />
    </div>

    <!-- Gift Tab Content (Teachers) -->
    <div v-if="isTeacher && activeTab === 'gift'" class="gift-section">
      <PageHeader title="Jegyátadás csoportoknak" subtitle="Add át a megmaradt jegyeket egyik csoporttól a másiknak">
        <template #icon>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 1l4 4-4 4"/>
            <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
            <path d="M7 23l-4-4 4-4"/>
            <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
          </svg>
        </template>
      </PageHeader>

      <div v-if="giftLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>Betöltés...</p>
      </div>

      <div v-else-if="giftGalas.length === 0" class="empty-state">
        <div class="empty-icon">🎟️</div>
        <h3>Nincs elérhető gála jegykiosztással</h3>
        <p>Az adminisztrátor még nem osztott ki jegyeket csoportonként.</p>
      </div>

      <div v-else class="gift-list">
        <div v-for="gg in giftGalas" :key="gg.gala_id" class="gift-card">
          <div class="gift-card-header">
            <h3>{{ ggGalaName(gg.gala_id) }}</h3>
            <span class="gift-max">Maximum: {{ gg.max_tickets }}</span>
          </div>
          <div class="gift-groups">
            <div v-for="g in gg.groups" :key="g.group_id" class="gift-group-row">
              <span class="gift-group-name">{{ g.group_name }}</span>
              <span class="gift-group-quota">
                Kiosztva: {{ g.quota }} / Szabad: {{ g.quota - g.committed }}
              </span>
              <button class="btn-gift" @click="openGift(gg, g)">Átadás innen</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Gift modal -->
      <div v-if="showGiftModal" class="modal-overlay" @click="closeGift">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3>Jegyátadás</h3>
            <button @click="closeGift" class="close-btn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
          <div class="modal-body" v-if="giftFrom">
            <p class="gift-from-info">
              <strong>{{ giftFrom.group_name }}</strong> csoporttól
              (szabad: {{ giftFrom.quota - giftFrom.committed }})
            </p>
            <div class="form-group">
              <label>Célcsoport</label>
              <select v-model="giftTarget" class="modern-input">
                <option v-for="g in giftTargets" :key="g.group_id" :value="g.group_id">
                  {{ g.group_name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Jegyek száma</label>
              <input type="number" min="1" :max="giftFrom.quota - giftFrom.committed"
                     v-model.number="giftAmount" class="modern-input" />
            </div>
            <div class="form-actions">
              <button type="button" @click="closeGift" class="btn-secondary">Mégse</button>
              <button type="button" @click="submitGift" class="btn-primary" :disabled="gifting">
                {{ gifting ? 'Mentés...' : 'Átadás' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Events Tab Content (For Everyone) -->
    <div v-if="(!isAdmin && !isTeacher) || activeTab === 'events'">
        <PageHeader title="Gála Események" subtitle="Tekintsd meg az elkövetkező gála eseményeket és jelezd vissza részvételi szándékodat">
          <template #icon>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12.01" y2="12"/>
            </svg>
          </template>
        </PageHeader>

    <div class="gala-content">
      <!-- Loading State -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>Betöltés...</p>
      </div>

      <!-- Error State -->
      <div v-if="error && !loading" class="error-container">
        <div class="error-icon">⚠️</div>
        <p>{{ error }}</p>
        <button @click="fetchGalas" class="btn-secondary">Újrapróbálás</button>
      </div>

      <!-- Galas Grid -->
      <div v-if="!loading && !error" class="section">
        <div class="section-header">
          <h2>Elkövetkező Gála Események</h2>
        </div>

        <!-- Empty State -->
        <div v-if="galas.length === 0" class="empty-state">
          <div class="empty-icon">🎭</div>
          <h3>Nincs elérhető gála esemény</h3>
          <p>Jelenleg nincs meghirdetett gála esemény.</p>
        </div>

        <!-- Galas Grid -->
        <div v-else class="galas-grid">
          <GalaCard
            v-for="gala in galas"
            :key="gala.id"
            :gala="gala"
            :show-price="true"
            :ticket-stats="ticketStats"
            :show-ticket-info="true"
            :my-group-ticket-info="myGroupTicketInfo[gala.id]"
          >
            <template v-slot:card-actions>

              <!-- Admin Statistics Section -->
              <div v-if="isAdmin" class="admin-stats-section">
                <div class="stats-header">
                  <h4>Admin statisztikák</h4>
                  <button @click="showGalaStats(gala)" class="btn-secondary btn-sm">
                    Részletek
                  </button>
                </div>
                <div class="stats-summary" v-if="galaStats[gala.id]">
                  <div class="stat-item">
                    <span class="stat-label">Jegyek összesen:</span>
                    <span class="stat-value">{{ galaStats[gala.id].total_tickets || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Várható bevétel:</span>
                    <span class="stat-value">{{ formatPrice(galaStats[gala.id].expected_revenue || 0) }} Ft</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Résztvevők:</span>
                    <span class="stat-value">{{ galaStats[gala.id].yes_count || 0 }}</span>
                  </div>
                </div>
              </div>

              <!-- User Response Section -->
              <div class="response-section">
                <h4>Részvételi szándék</h4>
                
                <!-- Current Response -->
                <div v-if="getUserResponse(gala.id)" class="current-response">
                  <div class="response-status" :class="`response-${getUserResponse(gala.id).response}`">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path v-if="getUserResponse(gala.id).response === 'yes'" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      <path v-else-if="getUserResponse(gala.id).response === 'no'" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      <path v-else d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    <span>{{ getResponseText(getUserResponse(gala.id).response) }}</span>
                    <span class="ticket-count" v-if="getUserResponse(gala.id).ticket_quantity > 0">
                      ({{ getUserResponse(gala.id).ticket_quantity }} jegy)
                    </span>
                  </div>
                </div>

                <!-- Response Form -->
                <div class="response-form">
                  <div class="response-options">
                    <label class="response-option yes-option">
                      <input 
                        type="radio" 
                        :name="`response-${gala.id}`" 
                        value="yes"
                        v-model="responses[gala.id].response"
                        @change="onResponseChange(gala.id)"
                      >
                      <span class="radio-custom yes"></span>
                      Igen, részt veszek
                    </label>
                    
                    <label class="response-option maybe-option">
                      <input 
                        type="radio" 
                        :name="`response-${gala.id}`" 
                        value="maybe"
                        v-model="responses[gala.id].response"
                        @change="onResponseChange(gala.id)"
                      >
                      <span class="radio-custom maybe"></span>
                      Még nem tudom
                    </label>
                    
                    <label class="response-option no-option">
                      <input 
                        type="radio" 
                        :name="`response-${gala.id}`" 
                        value="no"
                        v-model="responses[gala.id].response"
                        @change="onResponseChange(gala.id)"
                      >
                      <span class="radio-custom no"></span>
                      Nem tudok részt venni
                    </label>
                  </div>
                  
                  <!-- Ticket Quantity Selector -->
                  <div v-if="responses[gala.id].response === 'yes' && gala.ticket_price > 0" class="ticket-section">
                    <label class="ticket-label">
                      Jegyek száma:
                    </label>
                    <div class="ticket-controls">
                      <button 
                        type="button" 
                        @click="decreaseTickets(gala.id)"
                        class="ticket-btn minus"
                        :disabled="responses[gala.id].ticket_quantity <= 1"
                      >
                        −
                      </button>
                      <input 
                        id="ticket-quantity"
                        type="number" 
                        v-model.number="responses[gala.id].ticket_quantity"
                        @change="onTicketChange(gala.id)"
                        min="1"
                        max="20"
                        class="ticket-input modern-input"
                      >
                      <button 
                        type="button" 
                        @click="increaseTickets(gala.id)"
                        class="ticket-btn plus"
                        :disabled="responses[gala.id].ticket_quantity >= 20"
                      >
                        +
                      </button>
                    </div>
                    <div class="total-price" v-if="responses[gala.id].ticket_quantity > 0">
                      <strong>Összesen: {{ formatPrice(responses[gala.id].ticket_quantity * gala.ticket_price) }} Ft</strong>
                    </div>
                  </div>
                  
                  <button 
                    @click="submitResponse(gala.id)" 
                    class="btn-primary response-btn"
                    :disabled="savingResponse[gala.id]"
                  >
                    {{ savingResponse[gala.id] ? 'Mentés...' : 'Válasz küldése' }}
                  </button>
                </div>
              </div>
            </template>
          </GalaCard>
        </div>
      </div>
    </div>
    </div>

    <!-- Admin Statistics Modal -->
    <div v-if="showStatsModal && selectedGalaStats" class="modal-overlay" @click="closeStatsModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Gala részletes statisztikák</h3>
          <button @click="closeStatsModal" class="close-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <!-- Summary Statistics -->
          <div class="summary-stats">
            <h4>Összegzés</h4>
            <div class="stats-grid">
              <div class="stat-card">
                <div class="stat-number">{{ selectedGalaStats.total_tickets || 0 }}</div>
                <div class="stat-label">Összes jegy</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">{{ selectedGalaStats.yes_count || 0 }}</div>
                <div class="stat-label">Résztvevők</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">{{ selectedGalaStats.no_count || 0 }}</div>
                <div class="stat-label">Nem jönnek</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">{{ selectedGalaStats.maybe_count || 0 }}</div>
                <div class="stat-label">Nem tudja</div>
              </div>
            </div>
            <div class="revenue-summary">
              <h5>Várható bevétel: {{ formatPrice(selectedGalaStats.expected_revenue || 0) }} Ft</h5>
            </div>
          </div>

          <!-- Attendees List -->
          <div class="attendees-section">
            <h4>Résztvevők listája</h4>
            <div class="table-wrapper">
              <div class="attendees-table">
                <div class="table-header">
                  <div class="table-cell">Név</div>
                  <div class="table-cell">Email</div>
                  <div class="table-cell">Jegyek száma</div>
                  <div class="table-cell">Összeg</div>
                  <div class="table-cell">Fizetés</div>
                </div>
                <div v-for="attendee in selectedGalaStats.attendees || []" :key="attendee.id" class="table-row">
                  <div class="table-cell">{{ attendee.name }}</div>
                  <div class="table-cell">{{ attendee.email }}</div>
                  <div class="table-cell">{{ attendee.ticket_quantity }}</div>
                  <div class="table-cell">{{ formatPrice(attendee.total_amount) }} Ft</div>
                  <div class="table-cell">
                    <span v-if="attendee.payment_received && (!attendee.paid_amount || attendee.paid_amount >= attendee.total_amount)" class="payment-paid">Fizetve</span>
                    <div v-else-if="attendee.paid_amount && attendee.paid_amount > 0" class="partial-payment">
                      <span class="partial-amount">{{ formatPrice(attendee.paid_amount) }} Ft</span>
                      <button @click="showPaymentModal(selectedGalaStats.gala_id, attendee)" class="btn-payment btn-payment-small">
                        Részleges fizetés
                      </button>
                    </div>
                    <button v-else @click="showPaymentModal(selectedGalaStats.gala_id, attendee)" class="btn-payment">
                      Fizetés jelölése
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Modal -->
    <div v-if="showPaymentModalFlag" class="modal-overlay" @click="closePaymentModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Részleges fizetés kezelése</h3>
          <button @click="closePaymentModal" class="close-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="selectedAttendee" class="payment-form">
            <div class="attendee-info">
              <h4>{{ selectedAttendee.name }} ({{ selectedAttendee.email }})</h4>
              <p>Jegyek száma: {{ selectedAttendee.ticket_quantity }}</p>
              <p>Összesen fizetendő: {{ formatPrice(selectedAttendee.total_amount) }} Ft</p>
              <p v-if="selectedAttendee.paid_amount">Eddig fizetve: {{ formatPrice(selectedAttendee.paid_amount) }} Ft</p>
              <p v-if="selectedAttendee.paid_amount">Hátralék: {{ formatPrice(selectedAttendee.total_amount - selectedAttendee.paid_amount) }} Ft</p>
            </div>
            
            <form @submit.prevent="submitPayment" class="payment-form-body">
              <div class="form-group">
                <label for="paymentAmount">Fizetett összeg (Ft)</label>
                 <input 
                   id="paymentAmount" 
                   v-model.number="paymentData.amount" 
                   type="number" 
                   :min="0"
                   :max="selectedAttendee ? selectedAttendee.total_amount : 0"
                   step="any"
                   required 
                   class="modern-input"
                   placeholder="pl. 5000"
                 />
              </div>
              
              <div class="form-group">
                <label>
                  <input type="checkbox" v-model="paymentData.fullPayment">
                  Teljes összeg kiegyenlítése
                </label>
              </div>
              
              <div class="form-actions">
                <button type="button" @click="closePaymentModal" class="btn-secondary">Mégse</button>
                <button type="submit" class="btn-primary" :disabled="processingPayment">
                  {{ processingPayment ? 'Feldolgozás...' : 'Fizetés mentése' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastMixin from '../mixins/toast.js';
import GalaCard from './shared/GalaCard.vue';
import GalaItem from './GalaItem.vue';
import PageHeader from './shared/PageHeader.vue';

export default {
  name: 'PublicGalaItem',
  components: {
    GalaCard,
    GalaItem,
    PageHeader
  },
  mixins: [toastMixin],
  
  data() {
    return {
      galas: [],
      loading: false,
      error: null,
      responses: {},
      savingResponse: {},
      userResponses: {},
      galaStats: {},
      ticketStats: {},
      myGroupTicketInfo: {},
      showStatsModal: false,
      selectedGalaStats: null,
      showPaymentModalFlag: false,
      selectedAttendee: null,
      processingPayment: false,
      paymentData: {
        amount: 0,
        fullPayment: false
      },
      statsRefreshInterval: null,
      activeTab: 'events',
      giftGalas: [],
      giftLoading: false,
      showGiftModal: false,
      giftFrom: null,
      giftGala: null,
      giftTarget: null,
      giftTargets: [],
      giftAmount: 1,
      gifting: false,
      teacherGroupIds: [],
      allGiftAllocations: {}
    };
  },
  
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isTeacher() {
      return this.$store.getters.isTeacher;
    }
  },
  
  async mounted() {
    await this.fetchGalas();
    await this.fetchUserResponses();
    await this.fetchGalaStats();
    await this.fetchMyGroupTicketInfo();
    
    if (this.isTeacher) {
      await this.fetchGiftGalas();
    }
    if (this.isAdmin) {
      this.startStatsAutoRefresh();
    }
  },
  
  beforeUnmount() {
    // Clean up the interval when component is destroyed
    this.stopStatsAutoRefresh();
  },
  
  methods: {
    async fetchGalas() {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await axios.get(`${this.$BACKEND_HOST}/api/public/galas`);
        this.galas = response.data.galas || [];
        
        // Initialize response objects for each gala
        this.galas.forEach(gala => {
          this.responses[gala.id] = {
            response: '',
            ticket_quantity: 1
          };
          this.savingResponse[gala.id] = false;
        });
      } catch (error) {
        console.error('Error fetching galas:', error);
        this.error = 'Hiba történt a galák betöltésekor.';
        this.showToast('Hiba történt a galák betöltésekor!', 'error');
      } finally {
        this.loading = false;
      }
    },
    
    async fetchUserResponses() {
      try {
        const response = await axios.get(`${this.$BACKEND_HOST}/api/user/gala-responses`);
        const responses = response.data.responses || [];
        
        // Store responses by gala ID
        responses.forEach(resp => {
          this.userResponses[resp.gala_id] = resp;
        });
        
        // Initialize form data with existing responses
        this.galas.forEach(gala => {
          if (this.userResponses[gala.id]) {
            this.responses[gala.id].response = this.userResponses[gala.id].response;
            this.responses[gala.id].ticket_quantity = this.userResponses[gala.id].ticket_quantity;
          }
        });
      } catch (error) {
        console.error('Error fetching user responses:', error);
        // Don't show error toast for this as it's not critical
      }
    },
    
    async fetchGalaStats() {
      try {
        // Fetch stats for all galas (both admin and public users can see ticket availability)
        for (const gala of this.galas) {
          try {
            const response = await axios.get(`${this.$BACKEND_HOST}/api/gala/${gala.id}/stats`);
            this.galaStats[gala.id] = response.data.stats;
            
            // Extract ticket count info for public display
            const stats = response.data.stats;
            if (stats) {
              this.ticketStats[gala.id] = {
                sold_tickets: stats.yes_count || 0, // Count of "yes" responses
                total_tickets: stats.total_tickets || gala.max_tickets || 0
              };
            }
          } catch (error) {
            console.error(`Error fetching stats for gala ${gala.id}:`, error);
            // If stats can't be fetched, assume 0 sold tickets
            this.ticketStats[gala.id] = {
              sold_tickets: 0,
              total_tickets: gala.max_tickets || 0
            };
          }
        }
      } catch (error) {
        console.error('Error fetching gala stats:', error);
      }
    },

    async fetchMyGroupTicketInfo() {
      try {
        for (const gala of this.galas) {
          try {
            const response = await axios.get(`${this.$BACKEND_HOST}/api/gala/${gala.id}/my-group-tickets`);
            this.myGroupTicketInfo[gala.id] = response.data;
          } catch (error) {
            console.error(`Error fetching group ticket info for gala ${gala.id}:`, error);
            this.myGroupTicketInfo[gala.id] = null;
          }
        }
      } catch (error) {
        console.error('Error fetching group ticket info:', error);
      }
    },
    
    async showGalaStats(gala) {
      this.selectedGalaStats = this.galaStats[gala.id];
      this.showStatsModal = true;
    },
    
    closeStatsModal() {
      this.showStatsModal = false;
      this.selectedGalaStats = null;
    },
    
    showPaymentModal(galaId, attendee) {
      this.selectedAttendee = attendee;
      this.paymentData.amount = attendee.total_amount || 0;
      this.paymentData.fullPayment = false;
      this.showPaymentModalFlag = true;
    },
    
    closePaymentModal() {
      this.showPaymentModalFlag = false;
      this.selectedAttendee = null;
      this.paymentData.amount = 0;
      this.paymentData.fullPayment = false;
    },
    
    async markPaymentReceived(galaId, responseId) {
      try {
        await axios.put(`${this.$BACKEND_HOST}/api/gala/response/${responseId}/payment`, {
          payment_received: true
        });
        
        // Refresh stats
        await this.fetchGalaStats();
        this.showToast('Fizetés sikeresen jelölve!', 'success');
      } catch (error) {
        console.error('Error marking payment:', error);
        this.showToast('Hiba a fizetés jelölésekor!', 'error');
      }
    },
    
    async submitPayment() {
      if (!this.selectedAttendee) return;
      
      this.processingPayment = true;
      
      try {
        const paymentAmount = this.paymentData.fullPayment ?
          this.selectedAttendee.total_amount :
          this.paymentData.amount;
          
        const isFullPayment = this.paymentData.fullPayment ||
          paymentAmount >= this.selectedAttendee.total_amount;
          
        await axios.put(`${this.$BACKEND_HOST}/api/gala/response/${this.selectedAttendee.id}/payment`, {
          payment_received: isFullPayment,
          paid_amount: paymentAmount
        });
        
        // Update the attendee in the current stats without full refresh
        if (this.selectedGalaStats && this.selectedGalaStats.attendees) {
          const attendeeIndex = this.selectedGalaStats.attendees.findIndex(
            a => a.id === this.selectedAttendee.id
          );
          if (attendeeIndex !== -1) {
            this.selectedGalaStats.attendees[attendeeIndex].payment_received = isFullPayment;
            this.selectedGalaStats.attendees[attendeeIndex].paid_amount = paymentAmount;
          }
        }
        
        // Also update in the main galaStats cache
        for (const galaId in this.galaStats) {
          if (this.galaStats[galaId].attendees) {
            const attendeeIndex = this.galaStats[galaId].attendees.findIndex(
              a => a.id === this.selectedAttendee.id
            );
            if (attendeeIndex !== -1) {
              this.galaStats[galaId].attendees[attendeeIndex].payment_received = isFullPayment;
              this.galaStats[galaId].attendees[attendeeIndex].paid_amount = paymentAmount;
              break;
            }
          }
        }
        
        this.closePaymentModal();
        this.showToast('Fizetés sikeresen mentve!', 'success');
      } catch (error) {
        console.error('Error submitting payment:', error);
        this.showToast('Hiba a fizetés mentésekor!', 'error');
      } finally {
        this.processingPayment = false;
      }
    },
    
    async submitResponse(galaId) {
      const response = this.responses[galaId];
      
      if (!response.response) {
        this.showToast('Kérjük, válasszon egy válaszlehetőséget!', 'error');
        return;
      }
      
      // If attending, ensure at least 1 ticket is selected
      if (response.response === 'yes' && response.ticket_quantity < 1) {
        this.showToast('Ha részt vesz, kérjük adjon meg legalább 1 jegyet!', 'error');
        return;
      }
      
      this.savingResponse[galaId] = true;
      
      try {
        const requestData = {
          gala_id: galaId,
          response: response.response,
          ticket_quantity: response.ticket_quantity || 0
        };
        
        await axios.post(`${this.$BACKEND_HOST}/api/gala/response`, requestData);
        
        // Update local user responses
        this.userResponses[galaId] = {
          gala_id: galaId,
          response: response.response,
          ticket_quantity: response.ticket_quantity || 0
        };
        
        this.showToast('Válasz sikeresen elmentve!', 'success');
      } catch (error) {
        console.error('Error submitting response:', error);
        this.showToast('Hiba történt a válasz mentésekor!', 'error');
      } finally {
        this.savingResponse[galaId] = false;
      }
    },
    
    getUserResponse(galaId) {
      return this.userResponses[galaId];
    },
    
    getResponseText(response) {
      switch (response) {
        case 'yes': return 'Igen, részt veszek';
        case 'no': return 'Nem tudok részt venni';
        case 'maybe': return 'Még nem tudom';
        default: return '';
      }
    },
    
    onResponseChange(galaId) {
      // When response changes, reset ticket quantity if not attending
      if (this.responses[galaId].response !== 'yes') {
        this.responses[galaId].ticket_quantity = 0;
      }
      
      // Auto-submit when response changes
      if (this.responses[galaId].response) {
        this.submitResponse(galaId);
      }
    },
    
    onTicketChange(galaId) {
      // Auto-submit when ticket quantity changes
      if (this.responses[galaId].response === 'yes') {
        this.submitResponse(galaId);
      }
    },
    
    increaseTickets(galaId) {
      if (this.responses[galaId].ticket_quantity < 20) {
        this.responses[galaId].ticket_quantity++;
      }
    },
    
    decreaseTickets(galaId) {
      if (this.responses[galaId].ticket_quantity > 1) {
        this.responses[galaId].ticket_quantity--;
      }
    },
    
    handleImageError(event) {
      event.target.style.display = 'none';
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('hu-HU');
    },
    
    formatPrice(price) {
      return Math.round(price).toLocaleString('hu-HU');
    },
    
    startStatsAutoRefresh() {
      // Refresh stats every 30 seconds for admins
      this.statsRefreshInterval = setInterval(() => {
        if (this.isAdmin) {
          this.fetchGalaStats();
        }
      }, 5000); // 5 seconds
    },
    
    stopStatsAutoRefresh() {
      if (this.statsRefreshInterval) {
        clearInterval(this.statsRefreshInterval);
        this.statsRefreshInterval = null;
      }
    },

    async fetchGiftGalas() {
      this.giftLoading = true;
      try {
        if (this.isTeacher && !this.isAdmin) {
          try {
            const tg = await axios.get(`${this.$BACKEND_HOST}/api/teacher/groups`);
            this.teacherGroupIds = tg.data.group_ids || [];
          } catch (e) {
            this.teacherGroupIds = [];
          }
        } else {
          this.teacherGroupIds = [];
        }

        const res = await axios.get(`${this.$BACKEND_HOST}/api/public/galas`);
        const galas = res.data.galas || [];
        const allocations = [];
        this.allGiftAllocations = {};
        for (const gala of galas) {
          try {
            const ar = await axios.get(`${this.$BACKEND_HOST}/api/gala/${gala.id}/group-tickets`);
            let alloc = ar.data.allocation;
            if (alloc && alloc.groups && alloc.groups.length > 0) {
              this.allGiftAllocations[gala.id] = alloc;
              if (this.isTeacher && !this.isAdmin && this.teacherGroupIds.length > 0) {
                const owned = alloc.groups.filter(g => this.teacherGroupIds.includes(g.group_id));
                if (owned.length === 0) continue;
                alloc = { ...alloc, groups: owned };
              }
              allocations.push(alloc);
            }
          } catch (e) {
            console.error('gift alloc error', e);
          }
        }
        this.giftGalas = allocations;
      } catch (error) {
        console.error('Error fetching gift galas:', error);
      } finally {
        this.giftLoading = false;
      }
    },

    ggGalaName(galaId) {
      const gala = this.galas.find(g => g.id === galaId);
      return gala ? gala.name : ('Gála #' + galaId);
    },

    openGift(gg, group) {
      this.giftGala = gg;
      this.giftFrom = group;
      this.giftTarget = null;
      this.giftAmount = 1;
      const full = this.allGiftAllocations[gg.gala_id];
      const allGroups = full && full.groups ? full.groups : gg.groups;
      this.giftTargets = allGroups.filter(g => g.group_id !== group.group_id);
      this.showGiftModal = true;
    },

    closeGift() {
      this.showGiftModal = false;
      this.giftFrom = null;
      this.giftGala = null;
      this.giftTarget = null;
      this.giftAmount = 1;
    },

    async submitGift() {
      if (!this.giftFrom || !this.giftGala) return;
      const remaining = this.giftFrom.quota - this.giftFrom.committed;
      if (!this.giftTarget) {
        this.showToast('Válassz célcsoportot!', 'error');
        return;
      }
      if (this.giftAmount < 1 || this.giftAmount > remaining) {
        this.showToast('Érvénytelen jegyszám!', 'error');
        return;
      }
      this.gifting = true;
      try {
        await axios.post(`${this.$BACKEND_HOST}/api/gala/group-tickets/gift`, {
          gala_id: this.giftGala.gala_id,
          from_group_id: this.giftFrom.group_id,
          to_group_id: this.giftTarget,
          amount: this.giftAmount
        });
        this.showToast('Jegyek sikeresen átadva!', 'success');
        this.closeGift();
        await this.fetchGiftGalas();
      } catch (error) {
        console.error('Error gifting tickets:', error);
        let msg = 'Hiba a jegyátadáskor!';
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.showToast(msg, 'error');
      } finally {
        this.gifting = false;
      }
    }
  }
};
</script>

<style scoped>
.gala-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 4rem);
}

.admin-section {
  margin-bottom: 2rem;
}

.section-tabs {
  display: flex;
  gap: 1rem;
  background: var(--card-bg);
  padding: 1rem;
  border-radius: 12px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
}

.tab-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  color: var(--color-text);
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-button:hover {
  background: var(--color-background-mute);
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.tab-button.active {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  color: white;
  border-color: var(--primary-blue);
  box-shadow: var(--shadow-md);
}

.tab-button svg {
  flex-shrink: 0;
}

.section {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  margin-bottom: 2rem;
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.section-header h2 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

/* Loading and Error States */
.loading-container, .error-container {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--color-text-muted);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--primary-blue);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.error-container button {
  margin-top: 1rem;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--color-text-muted);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.empty-state h3 {
  color: var(--color-heading);
  margin-bottom: 0.5rem;
}

.empty-state p {
  margin-bottom: 2rem;
}

/* Galas Grid */
.galas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.5rem;
  padding: 2rem;
}

.gala-card {
  background: var(--color-background-mute);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  transition: all 0.3s ease;
  overflow: hidden;
}

.gala-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.gala-image {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: var(--color-background);
}

.gala-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gala-card:hover .gala-image img {
  transform: scale(1.05);
}

.no-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-muted);
  background: var(--color-background);
}

.gala-date-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

.gala-content {
  padding: 1.5rem;
}

.gala-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.gala-header h3 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  flex: 1;
}

.ticket-price {
  background: var(--primary-blue);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
}

.price-label {
  opacity: 0.9;
}

.price-value {
  font-weight: 700;
}

.gala-details {
  margin-bottom: 1.5rem;
}

.gala-location {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-text-muted);
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
}

.gala-location svg {
  flex-shrink: 0;
}

.gala-description p {
  color: var(--color-text);
  line-height: 1.5;
  font-size: 0.95rem;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Admin Statistics Styles */
.admin-stats-section {
  border-top: 1px solid var(--color-border);
  padding: 1rem;
  margin-bottom: 1.5rem;
  background: rgba(59, 130, 246, 0.05);
  border-radius: 8px;
}

.stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.stats-header h4 {
  color: var(--primary-blue);
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.btn-sm {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

.stats-summary {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background: var(--color-background);
  border-radius: 6px;
}

.stat-label {
  font-weight: 500;
  color: var(--color-text);
}

.stat-value {
  font-weight: 700;
  color: var(--primary-blue);
}

/* Response Section */
.response-section {
  border-top: 1px solid var(--color-border);
  padding-top: 1.5rem;
}

.response-section h4 {
  color: var(--color-heading);
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.current-response {
  margin-bottom: 1rem;
}

.response-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.95rem;
}

.response-status.response-yes {
  background: rgba(34, 197, 94, 0.1);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.response-status.response-no {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.response-status.response-maybe {
  background: rgba(251, 191, 36, 0.1);
  color: #d97706;
  border: 1px solid rgba(251, 191, 36, 0.2);
}

.ticket-count {
  opacity: 0.8;
}

/* Response Form */
.response-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 1.25rem;
}

.response-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.response-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.875rem 1rem;
  border-radius: 10px;
  transition: all 0.3s ease;
  border: 2px solid var(--color-border);
  background: var(--card-bg);
}

.response-option:hover {
  border-color: var(--primary-blue);
  transform: translateX(4px);
}

.response-option:has(input[type="radio"]:checked) {
  border-color: var(--primary-blue);
  background: rgba(59, 130, 246, 0.05);
}

.response-option:has(input[type="radio"]:checked).yes-option {
  border-color: #16a34a;
  background: rgba(34, 197, 94, 0.05);
}

.response-option:has(input[type="radio"]:checked).no-option {
  border-color: #dc2626;
  background: rgba(239, 68, 68, 0.05);
}

.response-option:has(input[type="radio"]:checked).maybe-option {
  border-color: #d97706;
  background: rgba(245, 158, 11, 0.05);
}

.response-option input[type="radio"] {
  display: none;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border: 2px solid var(--color-border);
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
}

.response-option input[type="radio"]:checked + .radio-custom.yes {
  border-color: #16a34a;
  background: #16a34a;
}

.response-option input[type="radio"]:checked + .radio-custom.no {
  border-color: #dc2626;
  background: #dc2626;
}

.response-option input[type="radio"]:checked + .radio-custom.maybe {
  border-color: #d97706;
  background: #d97706;
}

.radio-custom::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.response-option input[type="radio"]:checked + .radio-custom::after {
  opacity: 1;
}

/* Ticket Section */
.ticket-section {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 1rem;
}

.ticket-label {
  display: block;
  font-weight: 500;
  color: var(--color-heading);
  margin-bottom: 0.5rem;
}

.ticket-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.ticket-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--color-border);
  background: var(--color-background-mute);
  color: var(--color-text);
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.ticket-btn:hover:not(:disabled) {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}

.ticket-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ticket-input {
  width: 60px;
  height: 36px;
  text-align: center;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: var(--color-background);
  color: var(--color-text);
  font-weight: 600;
}

.total-price {
  color: var(--primary-blue);
  font-size: 0.95rem;
}

.response-btn {
  align-self: flex-start;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .gala-container {
    padding: 1rem;
  }
  
  .galas-grid {
    grid-template-columns: 1fr;
    padding: 1rem;
    gap: 1rem;
  }
  
  .section-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .modal-content {
    margin: 0.5rem;
    max-height: 95vh;
  }
  
  .table-header, .table-row {
    grid-template-columns: 1fr;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow-lg);
  max-width: 640px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid var(--color-border);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-background-soft);
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-heading);
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-text-muted);
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: var(--color-background);
  color: var(--color-text);
}

.modal-body {
  padding: 2rem;
}

.payment-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.attendee-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-border);
}

.attendee-info h4 {
  margin: 0;
  color: var(--color-heading);
  font-size: 1.1rem;
}

.attendee-info p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.payment-form-body {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.payment-form-body .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.payment-form-body .form-group label {
  font-weight: 600;
  color: var(--color-heading);
  font-size: 0.95rem;
}

.form-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--color-border);
}

/* Payment buttons */
.btn-payment {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  background: var(--button-primary);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.btn-payment:hover {
  background: var(--button-primary-hover);
  transform: translateY(-1px);
}

.btn-payment-small {
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
}

.payment-paid {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
}

.partial-payment {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.partial-amount {
  font-weight: 600;
  color: var(--primary-blue);
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .gala-container {
    padding: 1rem;
  }
  
  .galas-grid {
    grid-template-columns: 1fr;
    padding: 1rem;
    gap: 1rem;
  }
  
  .section-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .modal-content {
    margin: 0.5rem;
    max-height: 95vh;
  }
  
  .table-header, .table-row {
    grid-template-columns: 1fr;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .gala-container {
    padding: 0.5rem;
  }
  
  .section {
    border-radius: 12px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

/* Gift (teacher) tab */
.gift-section {
  margin-bottom: 2rem;
}

.gift-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem;
}

.gift-card {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

.gift-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.gift-card-header h3 {
  margin: 0;
  color: var(--color-heading);
  font-size: 1.1rem;
}

.gift-max {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}

.gift-groups {
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.gift-group-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.6rem;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
}

.gift-group-name {
  font-weight: 600;
  color: var(--color-heading);
  flex: 1;
  min-width: 120px;
}

.gift-group-quota {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}

.btn-gift {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.9rem;
  background: var(--primary-blue);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.btn-gift:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.gift-from-info {
  margin: 0 0 1rem;
  color: var(--color-text);
}
</style>